import { Observable } from 'rxjs';
import { AuthenticationService } from '@app/core/port/authentication.service';
import { AuthenticationOrchestratorService } from '@app/core/adapter/authentication-orchestrator.service';
import { UserService } from '@app/core/port/user.service';
import { UserStore } from '@app/core/store/user.store';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

export function initializeAutoConnectFactory(
  authenticationService: AuthenticationService,
  userService: UserService,
  userStore: UserStore,
  router: Router,
  http: HttpClient
): () => Observable<void> {
  if (!environment.production) {
    console.log('🔵 [BOOT] Auto-connect avec architecture séparée');
  }
  
  return () =>
    new Observable<void>((observer) => {
      if (!environment.production) {
        console.log('🎭 AUTO-CONNECT: Utilisation de l\'orchestrateur intelligent');
      }
      
      // Cast vers l'orchestrateur pour accéder à autoConnect()
      const orchestrator = authenticationService as AuthenticationOrchestratorService;
      
      orchestrator.autoConnect().subscribe({
        next: (userData) => {
          if (userData) {
            if (!environment.production) {
              console.log('✅ AUTO-CONNECT: Utilisateur connecté automatiquement');
            }
            userStore.load(userData);
          } else {
            if (!environment.production) {
              console.log('ℹ️ AUTO-CONNECT: Pas d\'utilisateur, état initialisé');
            }
            userStore.markInitialized();
          }
          observer.complete();
        },
        error: (error) => {
          console.error('❌ AUTO-CONNECT: Erreur:', error);
          userStore.markInitialized();
          observer.complete();
        }
      });
    });
}
